import React from 'react';

const IconFacebook = () => (
  <svg fill="#000000" viewBox="0 0 22 24" xmlns="http://www.w3.org/2000/svg">
    <g data-name="Layer 2">
      <g data-name="facebook">
        <rect  transform="rotate(180 12 12)" opacity="0" />

        <rect  transform="rotate(180 12 12)" opacity="0" />

        <path d="M13 22H9a1 1 0 0 1-1-1v-6.2H6a1 1 0 0 1-1-1v-3.6a1 1 0 0 1 1-1h2V7.5A5.77 5.77 0 0 1 14 2h3a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1h-3v1.6h3a1 1 0 0 1 .8.39 1 1 0 0 1 .16.88l-1 3.6a1 1 0 0 1-1 .73H14V21a1 1 0 0 1-1 1zm-3-2h2v-6.2a1 1 0 0 1 1-1h2.24l.44-1.6H13a1 1 0 0 1-1-1V7.5a2 2 0 0 1 2-1.9h2V4h-2a3.78 3.78 0 0 0-4 3.5v2.7a1 1 0 0 1-1 1H7v1.6h2a1 1 0 0 1 1 1z" />
      </g>
    </g>
  </svg>
);

export default IconFacebook;
